// src/data/sampleLoyaltyCards.js

import {
  FaCcVisa,
  FaUniversity,
  FaCcMastercard,
  FaApplePay,
  FaStore,
  FaShoppingCart,
  FaBuilding,
  FaTools,
  FaWarehouse,
  FaBoxOpen,
  FaBolt,
  FaGasPump,
  FaCoffee,
  FaHamburger,
  FaPizzaSlice,
  FaAppleAlt,
  FaRegCreditCard,
} from "react-icons/fa";
import { SiAmericanexpress } from "react-icons/si";
import { GiShoppingCart, GiEnergyShield } from "react-icons/gi";
import { MdLocalGroceryStore } from "react-icons/md";
import { BsShop } from "react-icons/bs";

const gradientCombos = [
  "bg-gradient-to-r from-red-500 to-blue-600",
  "bg-gradient-to-r from-yellow-400 to-red-500",
  "bg-gradient-to-r from-green-400 to-teal-500",
  "bg-gradient-to-r from-pink-500 to-purple-600",
  "bg-gradient-to-r from-indigo-400 to-sky-500",
  "bg-gradient-to-r from-orange-400 to-amber-500",
  "bg-gradient-to-r from-cyan-500 to-violet-600",
  "bg-gradient-to-r from-emerald-400 to-blue-600",
  "bg-gradient-to-r from-lime-400 to-green-600",
];

const brandList = [
  "Countdown",
  "New World",
  "Pak'nSave",
  "Kmart",
  "The Warehouse",
  "Mitre 10",
  "Bunnings",
  "Rebel Sport",
  "Briscoes",
  "JB Hi-Fi",
  "Farmers",
  "Noel Leeming",
  "Chemist Warehouse",
  "Z Energy",
  "BP",
  "Mobil",
  "Starbucks",
  "McDonald's",
  "Burger King",
  "Domino's Pizza",
];

export const brandColors = Object.fromEntries(
  brandList.map((brand) => [
    brand,
    gradientCombos[Math.floor(Math.random() * gradientCombos.length)],
  ])
);

export const brandLogos = {
  Countdown: <MdLocalGroceryStore className="text-white text-xl" />,
  "New World": <GiShoppingCart className="text-white text-xl" />,
  "Pak'nSave": <FaShoppingCart className="text-white text-xl" />,
  Kmart: <FaStore className="text-white text-xl" />,
  "The Warehouse": <FaWarehouse className="text-white text-xl" />,
  "Mitre 10": <FaTools className="text-white text-xl" />,
  Bunnings: <FaBuilding className="text-white text-xl" />,
  "Rebel Sport": <FaBoxOpen className="text-white text-xl" />,
  Briscoes: <BsShop className="text-white text-xl" />,
  "JB Hi-Fi": <FaBolt className="text-white text-xl" />,
  Farmers: <FaAppleAlt className="text-white text-xl" />,
  "Noel Leeming": <FaStore className="text-white text-xl" />,
  "Chemist Warehouse": <FaRegCreditCard className="text-white text-xl" />,
  "Z Energy": <GiEnergyShield className="text-white text-xl" />,
  BP: <FaGasPump className="text-white text-xl" />,
  Mobil: <FaGasPump className="text-white text-xl" />,
  Starbucks: <FaCoffee className="text-white text-xl" />,
  "McDonald's": <FaHamburger className="text-white text-xl" />,
  "Burger King": <FaHamburger className="text-white text-xl" />,
  "Domino's Pizza": <FaPizzaSlice className="text-white text-xl" />,
};

export const realBrands = Object.keys(brandColors);

const icons = [
  <FaCcVisa className="text-white text-2xl" />,
  <FaUniversity className="text-white text-2xl" />,
  <FaCcMastercard className="text-white text-2xl" />,
  <FaApplePay className="text-white text-2xl" />,
  <SiAmericanexpress className="text-white text-2xl" />,
];

// 🟡 Bonuses (global fixed)
const bonus1 = "10% off";
const bonus2 = "1 free";
const bonus3 = "20% off";
const bonus4 = "2 free";
const defaultBonuses = [bonus1, bonus2, bonus3, bonus4];

// 🟡 Reward + Terms + Contact (back card data)
const rewardMessages = [
  "Get $5 off your next purchase after collecting all stamps.",
  "Receive a free drink on your next visit after completing your card.",
  "Enjoy 20% off your next purchase after collecting all stamps.",
  "Buy 9 and get your 10th free!",
  "Claim a bonus item with every completed card.",
];

const termsTemplates = [
  "1. Earn 1 stamp per $10 spent. 2. Collect all stamps to redeem reward. 3. Rewards are not cash-redeemable. 4. No partial redemptions. 5. Final decisions rest with the store.",
  "1. One stamp per eligible purchase. 2. Completed cards must be presented to claim reward. 3. Cannot combine with other offers. 4. Lost cards won’t be replaced. 5. Valid in-store only.",
  "1. Stamps valid on full-price items only. 2. Reward valid 30 days after completion. 3. Cannot be used with coupons. 4. No partial use allowed. 5. Final decision by store.",
  "1. Get 1 stamp for every $15 spent. 2. Free item is selected by staff. 3. Non-transferable. 4. Not valid during promotions. 5. Reward must be used in one transaction.",
  "1. One stamp per $5 spent. 2. Reward cannot be split. 3. Cards cannot be combined. 4. No refunds on stamps or rewards. 5. Terms may change without notice.",
];

export const sampleCards = Array.from({ length: 30 }, (_, i) => {
  const id = i + 1;
  const brand = realBrands[i % realBrands.length];
  const color = brandColors[brand];
  const logo = brandLogos[brand];
  const icon = icons[i % icons.length];

  const supportedStampCounts = [5, 6, 7, 8, 9, 10, 12, 14, 15, 16, 20];
  const stampsselected =
    supportedStampCounts[
      Math.floor(Math.random() * supportedStampCounts.length)
    ];
  const stampCount = Math.floor(Math.random() * (stampsselected + 1)); // 0 to stampsselected

  let status = "ongoing";
  if (stampCount >= stampsselected) status = "completed";
  else if (i < 3) status = "new";

  return {
    id,
    name: `${brand} Loyalty`,
    brand,
    logo,
    icon,
    color,
    last4: `${1000 + id}`,
    type: "Loyalty",
    points: 10 + Math.floor(Math.random() * 200),
    rewards: `Exclusive deals at ${brand}`,
    status,
    stampCount,
    stampsselected,

    // 🆕 Back card
    cardDesc3: brand, // 🔧 fixed contact info
    cardDesc4: rewardMessages[i % rewardMessages.length],
    cardDesc5: termsTemplates[i % termsTemplates.length],

    // 🆕 Bonus levels
    bonuses: defaultBonuses,
  };
});
